import { min, sqrt } from "../math.js";
export default {
  draw: function draw(context, size) {
    var r = sqrt(size - min(size / 7, 2)) * 0.87559;
    context.moveTo(-r, 0);
    context.lineTo(r, 0);
    context.moveTo(0, r);
    context.lineTo(0, -r);
  }
};